import React from "react";
import { useHistory } from "react-router-dom";
import Button from "../Components/Button";
import ReportsLayout from "./ReportsLayout";
import AdminDiv from "../AdminDiv";

const Reports = () => {
  const history = useHistory();

  return (
    <ReportsLayout>
      <div className="text-black bg-gray-100 pb-8">
        <div className="mt-8 mx-8 py-20 px-12 text-black bg-white rounded-lg border">
          <div className="text-2xl -mt-4 pb-6 font-medium">
            Inventory Reports
          </div>
          <div className="flex justify-between">
            <Button
              onClick={() => history.push(`/reports/inventoryvalue`)}
              className="button"
              text="Inventory Value"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/productinventory`)}
              className="button"
              text="Product Inventory"
            ></Button>
            <div className="w-28"></div>
            <div className="w-28"></div>
          </div>
          <div className="text-2xl pt-10 pb-6 font-medium">Sales Reports</div>
          <div className="flex justify-between">
            <Button
              onClick={() => history.push(`/reports/events`)}
              className="button"
              text="Event Net"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/tour`)}
              className="button"
              text="Tour"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/sales`)}
              className="button"
              text="All Products"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/sales_new`)}
              className="button"
              text="All Products (New)"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/producttotals`)}
              className="button"
              text="Product Totals"
            ></Button>
          </div>
          <div className="flex justify-between mt-6">
            <Button
              onClick={() => history.push(`/reports/ctm-sales`)}
              className="button"
              text="TM Sales"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/artists-performance`)}
              className="button"
              text="Artists Performance"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/salessheet`)}
              className="button"
              text="Sales Sheet"
            ></Button>
          </div>
          <AdminDiv className="text-2xl pt-10 pb-6 font-medium">
            Financial Reports
          </AdminDiv>
          <AdminDiv className="flex justify-between">
            <Button
              onClick={() => history.push(`/reports/partnership`)}
              className="button"
              text="Partnership"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/cogs`)}
              className="button"
              text="COGS"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/promo`)}
              className="button"
              text="PROMO"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/taxes`)}
              className="button"
              text="Taxes"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/partnership_new`)}
              className="button"
              text="Partnership (New)"
            ></Button>
          </AdminDiv>
          <AdminDiv className="flex justify-between mt-6">
            <Button
              onClick={() => history.push(`/reports/ctmtaxes`)}
              className="button"
              text="Total Tax Liability"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/totalpayroll`)}
              className="button"
              text="Total Payroll"
            ></Button>
          </AdminDiv>
          <AdminDiv className="flex justify-between mt-6">
            <Button
              onClick={() => history.push(`/reports/deposits`)}
              className="button"
              text="Deposits"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/paymentsctm`)}
              className="button"
              text="Payments Due TM"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/paymentsvenue`)}
              className="button"
              text="Payments Due Venue"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/payroll`)}
              className="button"
              text="Payroll"
            ></Button>
          </AdminDiv>
          <AdminDiv className="flex justify-between mt-6">
            <Button
              onClick={() => history.push(`/reports/cash`)}
              className="button"
              text="Cash"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/accountsreceivable`)}
              className="button"
              text="Accounts Receivable"
            ></Button>
            <Button
              onClick={() => history.push(`/reports/accountspayable`)}
              className="button"
              text="Accounts Payable"
            ></Button>
            <AdminDiv className="w-28"></AdminDiv>
          </AdminDiv>
        </div>
      </div>
    </ReportsLayout>
  );
};

export default Reports;
